import { BodyColorBeige } from '@gds/Icons/Paths/BodyColorBeige';
import { BodyColorBlack } from '@gds/Icons/Paths/BodyColorBlack';
import { BodyColorBlue } from '@gds/Icons/Paths/BodyColorBlue';
import { BodyColorBrown } from '@gds/Icons/Paths/BodyColorBrown';
import { BodyColorGold } from '@gds/Icons/Paths/BodyColorGold';

import { BodyColorGreen } from '@gds/Icons/Paths/BodyColorGreen';
import { BodyColorGrey } from '@gds/Icons/Paths/BodyColorGrey';
import { BodyColorOrange } from '@gds/Icons/Paths/BodyColorOrange';

import { BodyColorOther } from '@gds/Icons/Paths/BodyColorOther';
import { BodyColorPurple } from '@gds/Icons/Paths/BodyColorPurple';

import { BodyColorRed } from '@gds/Icons/Paths/BodyColorRed';
import { BodyColorSilver } from '@gds/Icons/Paths/BodyColorSilver';
import { BodyColorWhite } from '@gds/Icons/Paths/BodyColorWhite';
import { BodyColorYellow } from '@gds/Icons/Paths/BodyColorYellow';

export const ICON_MAPPER = {
  beige: BodyColorBeige,
  black: BodyColorBlack,
  blue: BodyColorBlue,
  brown: BodyColorBrown,
  gold: BodyColorGold,
  green: BodyColorGreen,
  grey: BodyColorGrey,
  orange: BodyColorOrange,
  other: BodyColorOther,
  othercolor: BodyColorOther,
  red: BodyColorRed,
  purple: BodyColorPurple,
  silver: BodyColorSilver,
  white: BodyColorWhite,
  yellow: BodyColorYellow,
};
